import { Component, OnInit } from '@angular/core';
import { Title } from "@angular/platform-browser";

declare let $: any;

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit {

	constructor(private titleService:Title) {
		this.titleService.setTitle("Product");
	}

	ngOnInit(): void {

	}
  
	ngAfterViewInit(): void {
		setTimeout(function () {
			$.getScript('assets/scripts/jquery-3.3.1.js', function(){});
			let jsScript = document.createElement("script");
			jsScript.type = "text/javascript";
			jsScript.async = true;
			jsScript.innerHTML  = "$(document).ready(function () { $('.grecaptcha-badge').hide(); });";
			document.body.appendChild(jsScript); 
		},400);
	}

}
